module.exports = __webpack_public_path__ + "static/media/logo-raio-x.d9d8caa0.png";